import React from 'react';

// SLDS 2 page header: icon, title and subtitle; actions sit on the right
// and wrap underneath on small screens.
export default function PageHeader({ title, subtitle, icon: Icon, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5 p-4 bg-white border border-[#E5E5E5] rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.08)]">
      <div className="flex items-center gap-3 min-w-0">
        {Icon && (
          <div className="w-10 h-10 shrink-0 rounded-lg flex items-center justify-center bg-[#0176D3] text-white">
            <Icon size={20} strokeWidth={2} />
          </div>
        )}
        <div className="min-w-0">
          <h1 className="text-lg sm:text-xl font-bold text-[#2E2E2E] m-0 truncate">{title}</h1>
          {subtitle && <p className="text-[13px] mt-0.5 text-[#5C5C5C]">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
